import { connect } from 'react-redux'
import WorkshiftsComponent from '../../../components/employer/workshifts/workshifts.component'
import {
  getTotalApplications,
  getWorkshifts,
  getBillableHours,
  cancelDialog,
  removeWorkshift,
  closeWorkShiftSnackbar,
  getSignedLE,
  workshiftPageChange,
  showWorkshiftFormDialog,
  closeWorkshiftFormDialog,
  cancelEditWorkShift,
  loadProfileStart
} from '../../../actions/employer'

const mapStateToProps = (state) => {
  const isFilterLightEntre = state.workshifts.isFilterEmail
  const workShiftRowData = isFilterLightEntre
    ? state.workshifts.workshiftsFilter
    : state.workshifts.workshifts
  // .filter((el) => el.workshift_status_entrepreneur !== 1) // Filter out accepted one
  const billableHourRowData = isFilterLightEntre
    ? state.workshifts.billableHoursFilter
    : state.workshifts.billableHours
  const combinedData = [...workShiftRowData, ...billableHourRowData].sort(
    (a, b) => new Date(b.created_date) - new Date(a.created_date)
  )

  return {
    state,
    workshiftData: combinedData,
    billableHourData: state.workshifts.billableHours,
    showDeleteDialog: state.workshifts.showDeleteDialog,
    deleteWorkshiftid: state.workshifts.deleteWorkshiftid,
    deleteWorkshiftItemid: state.workshifts.deleteWorkshiftItemid,
    showAddSnackbar: state.workshifts.showAddSnackbar,
    showFailedAddSnackbar: state.workshifts.showFailedAddSnackbar,
    showEditSnackbar: state.workshifts.showEditSnackbar,
    showFailedEditSnackbar: state.workshifts.showFailedEditSnackbar,
    signedLightEntrepreneurs: state.workshifts.signedLightEntrepreneurs,
    isFilterEmail: state.workshifts.isFilterEmail,
    workshiftsFilter: state.workshifts.workshiftsFilter,
    billableHoursFilter: state.workshifts.billableHoursFilter,
    getWorkshiftDataSuccess: state.workshifts.getWorkshiftDataSuccess,
    getBillableHourDataSuccess: state.workshifts.getBillableHourDataSuccess,
    isEditWorkshift: state.workshifts.isEditWorkshift,
    selected: state.workshifts.selected,
    showWorkshiftForm: state.workshifts.showWorkshiftForm
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getTotalApplications: () => dispatch(getTotalApplications()),
    getWorkshifts: () => dispatch(getWorkshifts()),
    getBillableHours: () => dispatch(getBillableHours()),
    cancelDialog: () => dispatch(cancelDialog()),
    removeWorkshift: (workshiftid, workshift_itemid) =>
      dispatch(removeWorkshift(workshiftid, workshift_itemid)),
    closeWorkShiftSnackbar: () => dispatch(closeWorkShiftSnackbar()),
    getSignedLE: () => dispatch(getSignedLE()),
    workshiftPageChange: (selected) => dispatch(workshiftPageChange(selected)),
    showWorkshiftFormDialog: () => dispatch(showWorkshiftFormDialog()),
    closeWorkshiftFormDialog: () => dispatch(closeWorkshiftFormDialog()),
    cancelEditWorkShift: () => dispatch(cancelEditWorkShift()),
    loadProfileStart: () => dispatch(loadProfileStart())
  }
}

const WorkshiftsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkshiftsComponent)

export default WorkshiftsContainer
